<template>
  <Tab @close="removeCurrent">
    <template #toolbar-help>
      <v-btn class="tw-mr-2" fab text x-small :title="$t('dashboard.help.show')" @click="showHelp(menu,page)">
            <span class="mr-1">
              <v-icon color="primary" x-small>fa fa-question</v-icon>
            </span>
      </v-btn>
    </template>
    <template #toolbar-items>
      <!-- mes websites -->
      <TabToolbarButton
          v-model="page"
          :menu="menu"
          :selected="page === 'sites'"
          icon="fa-globe"
          name="sites"
      ></TabToolbarButton>
      <!-- ma page personnelle  Removed 29/10/22 -->
      <TabToolbarButton v-if="false"
          v-model="page"
          :menu="menu"
          :selected="page === 'editor'"
          icon="fa-pager"
          name="editor"
      ></TabToolbarButton>
    </template>
    <template #container>
      <!-- Mes websites  -->
      <TabPage :menu="menu" :page="page" documentation-path="manager/websites/page" name="sites">
        <template #content>
          <v-container>
            <!-- Main dialog website actions -->
            <v-dialog v-model="actionsDialog" max-width="900" >
              <v-card>
                <v-card-title class="headline">
                  {{ $t("websites.dialogs.actions.title") }} {{ website.host }}
                </v-card-title>

                <v-card-text class="mt-4">
                  <v-row>
                    <v-col>
                      <div style="display: flex;flex-direction: column;margin-top: 16px">
                        <div>{{ $t('websites.dialogs.actions.label_actions') }}</div>
                        <v-btn class="mt-4"  :title="$t('websites.rate')" small @click="rateNow(website)">
                          {{ $t('websites.dialogs.actions.btn_count') }}
                        </v-btn>
                        <br/><br/>
                        <div>{{ $t('websites.dialogs.actions.label_actions_criticals') }}</div>
                        <v-btn class="mt-4" :title="$t('websites.verify')" color="warning" small @click="verify(website)" :loading="website.loading">
                          {{ $t('websites.dialogs.actions.btn_verify') }}
                        </v-btn>
                        <v-btn class="mt-4" :title="$t('websites.reset')" color="warning" small @click="openResetDialog(website)">
                          {{ $t('websites.dialogs.actions.btn_change_key') }}
                        </v-btn>
                        <v-btn class="mt-4" :title="$t('websites.delete')" color="warning" small @click="openRemoveDialog(website)">
                          {{ $t('websites.dialogs.actions.btn_delete') }}
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <div style="margin-left: 10px">
                    <v-icon x-small>fa-link</v-icon>
                    <a style="margin-left:5px;" target="_BLANC" :href="'https://securating.com/les-avis-clients/'+website.host">{{ $t('websites.dialogs.actions.attestation') }}</a>
                  </div>
                  <v-spacer/>
                  <v-btn color="" text @click="actionsDialog = false">
                    {{ $t("common.close") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- Main dialog website updates -->
            <v-dialog v-model="editDialog" max-width="900" scrollable >
              <v-card height="90vh">
                <v-card-title class="headline">
                  {{ $t("websites.dialogs.edit.title") }} {{ website.host }}
                </v-card-title>

                <v-card-text class="mt-4" style="height: 80%;">
                  <v-tabs vertical>
                    <v-tab style="justify-content: normal;">
                      {{ $t("websites.dialogs.edit.tabs.notification.title") }}
                    </v-tab>
                    <v-tab style="justify-content: normal;">
                      {{ $t("websites.dialogs.edit.tabs.contact.title") }}
                    </v-tab>
                    <v-tab style="justify-content: normal;">
                      {{ $t("websites.dialogs.edit.tabs.share.title") }}
                    </v-tab>
                    <v-tab style="justify-content: normal;">
                      {{ $t("websites.dialogs.edit.tabs.display.title") }}
                    </v-tab>
                    <v-tab-item>
                      <v-card style="margin-left: 10px;">
                        <v-card-text>
                          <v-row>
                            <v-col>
                              <div class="mt-2">{{ $t('websites.dialogs.edit.label_notification_email') }}</div>
                              <v-text-field v-model="website.notification_email"
                                            solo
                                            type="email"
                              ></v-text-field>

                              <div class="mt-2">{{ $t('websites.dialogs.edit.label_notification_name') }}</div>
                              <v-text-field v-model="website.notification_name"
                                            solo

                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item>
                      <v-card style="margin-left: 10px;">
                        <v-card-text>
                          <div class="sr-title">
                            {{ $t("websites.dialogs.edit.label_contact_title") }}
                          </div>
                          <v-row id="account_website_logo" style="margin-top: 10px;">
                            <v-col>
                              <AvatarField
                                  v-if="website.hasOwnProperty('logo')"
                                  :src="website.logo"
                                  i18n="websites.dialogs.edit.label_contact_logo"
                                  with-upload
                                  @uploaded="updateWebsiteLogo"
                                  content="logo"
                              />
                            </v-col>
                          </v-row>
                          <v-row id="account_website_headline">
                            <v-col cols="12">
                              <FormField
                                  v-model="website.public_name"
                                  :props="{ maxLength: 255 }"
                                  i18n="websites.dialogs.edit.label_contact_public_name"
                                  input-type="text"
                              />
                            </v-col>
                            <v-col cols="12">
                              <FormField
                                  v-model="website.headline"
                                  :props="{ maxLength: 255 }"
                                  i18n="websites.dialogs.edit.label_contact_headline"
                                  input-type="text"
                              />
                            </v-col>

                          </v-row>
                          <v-row id="account_website_street">
                            <v-col cols="12">
                              <FormField
                                  v-model="website.street"
                                  :props="{ maxLength: 100 }"
                                  i18n="websites.dialogs.edit.label_contact_street"
                                  input-type="text"
                              />
                            </v-col>
                          </v-row>
                          <v-row id="account_website_further_information">
                            <v-col cols="12">
                              <FormField
                                  v-model="website.further_information"
                                  :props="{ maxLength: 255 }"
                                  i18n="websites.dialogs.edit.label_contact_further_information"
                                  input-type="text"
                              />
                            </v-col>
                          </v-row>
                          <v-row id="account_website_country">
                            <v-col cols="4">
                              <FormField
                                  v-model="website.zip"
                                  :props="{ maxLength: 9 }"
                                  i18n="websites.dialogs.edit.label_contact_zip"
                                  input-type="text"
                              />
                            </v-col>
                            <v-col cols="4">
                              <FormField
                                  v-model="website.city"
                                  :props="{ maxLength: 60 }"
                                  i18n="websites.dialogs.edit.label_contact_city"
                                  input-type="text"
                              />
                            </v-col >
                            <v-col cols="4">
                              <FormField
                                  v-model="website.country"
                                  :props="{ maxLength: 60 }"
                                  i18n="websites.dialogs.edit.label_contact_country"
                                  input-type="text"
                              />
                            </v-col>
                          </v-row>
                          <v-row id="account_website_email">
                            <v-col cols="8">
                              <FormField
                                  v-model="website.email"
                                  :props="{ maxLength: 255 }"
                                  i18n="websites.dialogs.edit.label_contact_email"
                                  input-type="email"
                                  rules="required|email"
                              />
                            </v-col>
                            <v-col cols="4">
                              <FormField
                                  v-model="website.phone"
                                  :props="{ maxLength: 15 }"
                                  i18n="websites.dialogs.edit.label_contact_phone"
                                  input-type="tel"
                              />
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item>
                      <v-card style="margin-left: 10px;">
                        <v-card-text>
                          <v-row>
                            <v-col>
                              <div class="mt-2">{{ $t('websites.dialogs.edit.label_authorized') }}</div>
                              <v-combobox v-model="authorizedHosts"
                                          clearable
                                          hide-selected
                                          multiple
                                          small-chips
                                          solo
                              ></v-combobox>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item>
                      <v-card style="margin-left: 10px;">
                        <v-card-text>
                          <v-row>
                            <v-col>
                              <span>{{ $t("websites.dialogs.edit.label_menu") }}</span>
                              <v-switch v-model="website.menu_visible"
                                        :label="(website.menu_visible)||(website.menu_visible==null)
                                  ? $t('websites.dialogs.edit.menu_yes')
                                  : $t('websites.dialogs.edit.menu_no')
                              "
                                        inset
                                        :disabled="(website.plan_id==0)||(website.plan_id==null)"
                              ></v-switch>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                </v-card-text>
                <v-card-actions>
                  <div style="margin-left: 10px">
                    <v-icon x-small>fa-link</v-icon>
                    <a style="margin-left:5px;" target="_BLANC" :href="'https://securating.com/les-avis-clients/'+website.host">{{ $t('websites.dialogs.actions.attestation') }}</a>
                  </div>
                  <v-spacer/>
                  <v-btn color="" text @click="editDialog = false">
                    {{ $t("common.cancel") }}
                  </v-btn>
                  <v-btn color="success" text @click="saveWebsiteData">
                    {{ $t("common.save") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- Dialog to confirm the hash reset -->
            <v-dialog v-model="resetDialog" max-width="490">
              <v-card>
                <v-card-title class="headline">
                  {{ $t("websites.dialogs.reset.title") }}
                </v-card-title>

                <v-card-text>
                  <div>{{ $t("websites.dialogs.reset.text") }}</div>
                </v-card-text>

                <v-card-actions>
                  <v-spacer/>

                  <v-btn text @click="resetDialog = false">
                    {{ $t("common.no") }}
                  </v-btn>

                  <!-- Yes button will call the remove method to delete the selected review from the list -->
                  <v-btn color="red darken-1" text @click="reset(website)">
                    {{ $t("common.yes") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- Dialog to confirm the site removal -->
            <v-dialog v-model="removeDialog" max-width="490">
              <v-card>
                <v-card-title class="headline">
                  {{ $t("websites.dialogs.remove.title") }}
                </v-card-title>

                <v-card-text>
                  <div>{{ $t("websites.dialogs.remove.text") }}</div>
                  <div class="tw-mt-2 tw-font-semibold">
                    {{ website.host }}
                  </div>
                  <div>{{ website.public_key }}</div>
                </v-card-text>

                <v-card-actions>
                  <v-spacer/>

                  <v-btn color="" text @click="removeDialog = false">
                    {{ $t("common.no") }}
                  </v-btn>

                  <!-- Yes button will call the remove method to delete the selected review from the list -->
                  <v-btn color="red darken-1" text @click="del(website);">
                    {{ $t("common.yes") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- Dialog to attribute tokens -->
            <v-dialog v-model="tokenDialog" max-width="640">
              <v-card>
                <v-card-title class="headline">
                  {{ $t("websites.dialogs.tokens.title") }}
                </v-card-title>

                <v-card-text>
                  <div>{{ $t("websites.dialogs.tokens.text") }}</div>

                  <div class="ml-2 mt-2 font-weight-bold">• {{ tokenSite.host }}</div>

                  <div class="mt-4 tw-flex tw-items-center tw-justify-around">
                    <div>
                      <div v-for="(availableTokens, plan) in tokens" :key="plan" class="ma-2">
                        <v-badge
                            :content="availableTokens.length"
                            :title="$t('websites.dialogs.tokens.available')"
                            bordered
                            color="primary"
                            overlap
                        >
                          <v-btn
                              :color="tokenLoading ? 'grey' : $t('websites.dialogs.tokens.color_' + plan)"
                              dark
                              @click="tokenLoading ? () => {} : linkToken(plan)"
                          >
                            {{ $t("websites.dialogs.tokens.plan_" + plan) }}
                          </v-btn>
                        </v-badge>
                      </div>
                      <div v-if="Object.keys(tokens).length <= 0" class="ma-2">
                        {{ $t("websites.dialogs.tokens.nothing_available") }}
                      </div>
                    </div>

                    <v-progress-circular v-if="tokenLoading" color="primary" indeterminate></v-progress-circular>
                    <div v-else>
                      <v-icon>fa fa-arrow-right</v-icon>
                    </div>

                    <div>
                      <div v-for="(availableTokens, plan) in usedTokens" :key="plan" class="ma-2">
                        <v-badge
                            :content="availableTokens.length"
                            :title="$t('websites.dialogs.tokens.available')"
                            bordered
                            color="primary"
                            overlap
                        >
                          <v-btn :color="$t('websites.dialogs.tokens.color_' + plan)" dark>
                            {{ $t("websites.dialogs.tokens.plan_" + plan) }}
                          </v-btn>
                        </v-badge>
                      </div>
                      <div v-if="Object.keys(usedTokens).length <= 0" class="ma-2">
                        {{ $t("websites.dialogs.tokens.nothing_used") }}
                      </div>
                    </div>
                  </div>

                  <div style="margin-top: 25px;">{{ $t("websites.dialogs.tokens.source") }}</div>
                </v-card-text>

                <v-card-actions>
                  <v-spacer/>

                  <v-btn color="" text @click="tokenDialog = false">
                    {{ $t("common.close") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>


            <div class="sr-title tw-mt-6 tw-mb-4">
              {{ $t("websites.table.title") }}
              <div class="float-right" style="position:relative; top:-5px;">
                <v-btn :title="$t('websites.refresh')" color="primary" icon @click="getWebsites">
                  <v-icon x-small>fa-sync-alt</v-icon>
                </v-btn>
              </div>
            </div>

            <div class="sr-title tw-mb-4" style="max-width: 500px;">
              <Form ref="website" :callback="addWebsite">
                <FormField
                    v-model="form.host"
                    i18n="websites.form.add_host"
                    :props="{hideDetails: true, class: 'sr-inline-form-align'}"
                    input-type="text"
                >
                  <template #append-outer>
                    <v-btn color="primary" small @click="$refs.website.validate()">
                      {{ $t("websites.form.host") }}
                    </v-btn>
                  </template>
                </FormField>
              </Form>
            </div>

            <!-- Table that contain all added websites -->
            <v-simple-table>
              <template v-slot:default>
                <thead>
                <tr>
                  <th>{{ $t("websites.table.host") }}</th>
                  <th>{{ $t("websites.table.hash") }}</th>
                  <th>{{ $t("websites.table.plan") }}</th>
                  <th>{{ $t("websites.table.status") }}</th>
                </tr>
                </thead>
                <tbody>
                <!-- Added websites -->
                <tr v-for="site in websites" :key="site.database + site.id + site.host">
                  <td>
                    <span>{{ site.host }}</span>
                  </td>
                  <td>
                    <v-icon
                        v-if="site.verified === 0"
                        :title="$t('websites.verified_l0')"
                        class="tw-mx-2"
                        color="warning"
                        small
                    >
                      fa-exclamation-triangle
                    </v-icon>
                    <v-icon
                        v-if="site.verified >= 1"
                        :title="$t('websites.verified_l1')"
                        class="tw-mx-2"
                        color="success"
                        small
                    >
                      fa-certificate
                    </v-icon>
                    <v-progress-circular
                        v-if="site.verified === -1"
                        :size="20"
                        :width="3"
                        class="tw-mx-2"
                        color="grey"
                        indeterminate
                    ></v-progress-circular>
                    <span :title="$t('websites.title_key')" class="action monospace" @click="downloadToken(site)">
                        {{ shorterHash(site.public_key) }}
                    </span>
                  </td>
                  <td>
                    <v-btn :title="$t('websites.plan.change')" icon small @click="openTokenDialog(site)">
                      <v-icon x-small>
                        fa-exchange-alt
                      </v-icon>
                    </v-btn>
                    <span>{{ $t("websites.dialogs.tokens.plan_" + (site.plan_id == null ? "0" : site.plan_id)) }}</span>
                  </td>
                  <td>

                    <v-btn :title="$t('websites.dialogs.edit.title')" icon small @click="openEditDialog(site)">
                      <v-icon x-small>
                        fa-edit
                      </v-icon>
                    </v-btn>
                    <v-btn :title="$t('websites.dialogs.actions.title')" icon small @click="openActionsDialog(site)">
                      <v-icon x-small>
                        fa-list
                      </v-icon>
                    </v-btn>
                    <v-btn :title="$t('websites.download.title')" icon small @click="downloadReviews(site)">
                      <v-icon x-small>
                        fa-download
                      </v-icon>
                    </v-btn>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-container>
        </template>
      </TabPage>

      <!-- ma page personnelle Removed 29/10/22 -->
      <TabPage v-if="false" :menu="menu" :page="page" name="editor" no-documentation>
        <template #content>
          <v-row>
            <!-- Wall editor -->
            <v-col cols="12" lg="4" md="6">
              <v-card>
                <v-container>
                  <span class="sr-title">
                    <!-- List title -->
                    {{ $t("wall.manager.editor.title") }}
                  </span>
                </v-container>
                <v-card-text v-if="wall === null">
                  <div class="sr-title mb-4">{{ $t("wall.manager.editor.claim") }}</div>
                  <v-text-field
                      v-model="domain"
                      :label="$t('wall.manager.editor.domain')"
                      :prefix="$t('wall.manager.editor.domain_prefix')"
                      :suffix="$t('wall.manager.editor.domain_suffix')"
                      @input="cleanDomain"
                  ></v-text-field>
                  <v-btn
                      :disabled="domain.length <= 0 || antiSpam"
                      :loading="antiSpam"
                      color="primary"
                      small
                      @click="claimDomain"
                  >
                    {{ $t("wall.manager.editor.claim_domain") }}
                  </v-btn>
                </v-card-text>
                <v-card-text v-else>
                  <div class="sr-title mb-2">{{ $t("wall.manager.editor.domain") }}</div>
                  <div class="mb-4">
                    {{ $t("wall.manager.editor.domain_prefix") }}{{
                      wall.domain
                    }}{{ $t("wall.manager.editor.domain_suffix") }}
                  </div>

                  <div class="sr-title mb-4">{{ $t("wall.manager.editor.activity") }}</div>

                  <v-text-field v-model="wall.address" :label="$t('wall.manager.editor.form.address')"></v-text-field>
                  <CategoriesField :category.sync="wall.category_id">
                    <template #append-outer>
                      <Tooltip i18n="wall.manager.editor.form.category"/>
                    </template>
                  </CategoriesField>

                  <hr class="mt-6"/>
                  <div class="sr-title mt-6 mb-4">{{ $t("wall.manager.editor.claimed") }}</div>
                  <v-text-field v-model="wall.title" :label="$t('wall.manager.editor.form.title')"></v-text-field>
                  <div class="mb-4 text--primary">{{ $t("wall.manager.editor.form.description") }}</div>
                  <ckeditor
                      v-model="editorContent"
                      :config="editorConfig"
                      :editor="editor"
                      @input="renderContent"
                  ></ckeditor>
                  <hr class="mt-6"/>

                  <v-file-input
                      v-model="images"
                      :label="$t('wall.manager.editor.form.images')"
                      counter="5"
                      multiple
                      show-size
                      small-chips
                      truncate-length="50"
                  ></v-file-input>

                  <div class="tw-flex tw-flex-wrap">
                    <div class="wall-image" v-for="image in wallImages" :key="image.id">
                      <img :src="image.url"/>
                      <div class="wall-image-infos">
                        <span>{{ image.virtual_path.split("/").pop() }}</span>
                        <v-btn x-small color="error" @click="removeImage(image)"
                        >{{ $t("websites.delete_image") }}
                        </v-btn>
                      </div>
                    </div>
                  </div>

                  <hr class="mt-6"/>
                  <div class="sr-title mt-6 mb-4">{{ $t("wall.manager.editor.meta") }}</div>
                  <v-text-field
                      v-model="wall.meta_title"
                      :label="$t('wall.manager.editor.form.meta_title')"
                  ></v-text-field>
                  <v-textarea
                      v-model="wall.meta_description"
                      :label="$t('wall.manager.editor.form.meta_description')"
                      auto-grow
                      no-resize
                  ></v-textarea>
                  <v-combobox
                      v-model="wall.meta_tags"
                      :label="$t('wall.manager.editor.form.meta_tags')"
                      deletable-chips
                      multiple
                      small-chips
                  ></v-combobox>

                  <v-btn :disabled="antiSpam" :loading="antiSpam" color="primary" small @click="updateWall">
                    {{ $t("wall.manager.editor.update_wall") }}
                  </v-btn>
                  <v-btn :disabled="antiSpam" color="error" class="ml-4" small @click="deleteWall">
                    {{ $t("wall.manager.editor.delete_wall") }}
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>

            <!-- No Selected review -->
            <v-col cols="12" lg="8" md="6">
              <v-card class="mx-auto">
                <iframe
                    v-if="wallIframeReady"
                    allowfullscreen="true"
                    loading="lazy"
                    :src="wallIframe"
                    style="border: none; height: calc(100vh - 100px); position: sticky"
                    width="100%"
                ></iframe>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </TabPage>
    </template>
  </Tab>
</template>

<script>
import tab from "../../../../mixins/tab"
import {Types as TypesSnackbar} from "../../../../store/modules/snackbar"
import {groupBy} from "lodash"
import ClassicEditor from "ckeditor5-build-custom"
import CategoriesField from "@/components/common/Form/CategoriesField"

export default {
  name: "Websites",
  mixins: [tab],
  components: {
    CategoriesField,
  },
  data: () => ({
    removeDialog: false,
    actionsDialog: false,
    editDialog: false,
    authorizedHosts: [],
    resetDialog: false,
    tokenDialog: false,
    tokenSite: {},
    usedTokens: {},
    tokens: {},
    tokenLoading: false,
    websites: [],
    website: {},
    form: {},
    pages: ["sites", "editor", "reviews_params"],
    page: "sites",
    menu: "websites",
    params_websites: [],
    images: [],
    valid: false,
    params: {
      order: "last",
      website_id: 0,
    },
    snackbar: false,
    snackbarTimeout: 2000,
    snackbarText: "",
    snackbarColor: "success",
    wall: null,
    wallIframe: "",
    wallIframeReady: false,
    wallImages: [],
    domain: "",
    domainTypingTimeout: null,
    antiSpam: false,
    antiSpamTimeout: null,
    editorMode: false,
    editor: ClassicEditor,
    editorContent: null,
    editorConfig: {
      language: "fr",
      toolbar: [
        "heading",
        "|",
        "bold",
        "italic",
        "|",
        "alignment",
        "|",
        "fontColor",
        "fontBackgroundColor",
        "|",
        "link",
        "|",
        "bulletedList",
        "numberedList",
      ],
    },
  }),
  mounted() {
    this.reloadPreviousOpenedTab()
    this.getWebsites()

    this.params.website_id = 0
    this.fetchWall()
  },
  methods: {
    handleError(i18n = "") {
      this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
        lines: this.$t(i18n),
        config: {timeout: 1000 * 6, color: "error"},
      })
    },
    handleSuccess(i18n = "") {
      this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
        lines: this.$t(i18n),
        config: {timeout: 1000 * 6, color: "success"},
      })
    },
    cleanWallResponse(response) {
      let wall = response.data
      if (wall.meta_tags) {
        wall.meta_tags = wall.meta_tags.split(",")
      }
      if (wall.description) {
        this.editorContent = wall.description
      }
      if (wall.images) {
        this.wallImages = JSON.parse(wall.images)
        if (typeof this.wallImages === "object") {
          this.wallImages = Object.values(this.wallImages)
        } else {
          this.wallImages = []
        }
      }
      this.wall = wall
    },
    fetchWall() {
      this.$axios
          .get("office/manager/wall")
          .then(response => {
            this.cleanWallResponse(response)
            this.reloadWallIframe()
          })
          .catch(() => {
            this.wall = null
          })
          .finally(() => this.disableAntiSpam())
    },
    reloadWallIframe() {
      this.wallIframeReady = false
      this.wallIframe = ""
      this.$nextTick(() => {
        this.wallIframe =
            window.location.hostname === "localhost"
                ? "http://localhost:8085/" + this.wall.domain
                : "https://securating.pro/" + this.wall.domain
        this.wallIframeReady = true
      })
    },
    removeImage(image) {
      this.$axios
          .delete("office/manager/wall/image", {params: {wall_id: this.wall.id, hash: image.hash}})
          .then(() => {
            this.wallImages = this.wallImages.filter(i => i.hash !== image.hash)
            this.reloadWallIframe()
            this.handleSuccess("wall.manager.editor.success.delete_image")
          })
          .catch(() => {
            this.handleError("wall.manager.editor.error.delete_image")
          })
    },
    enableAntiSpam() {
      if (this.antiSpam === false) {
        this.antiSpam = true
      }
    },
    disableAntiSpam() {
      if (this.antiSpam === true && this.antiSpamTimeout === null) {
        this.antiSpamTimeout = window.setTimeout(() => {
          this.antiSpam = false
          this.antiSpamTimeout = null
        }, 1000)
      }
    },
    claimDomain() {
      this.removeRemainingBadCharacters()
      this.enableAntiSpam()
      this.$axios
          .post("office/manager/wall/add", {domain: this.domain})
          .then(response => {
            this.cleanWallResponse(response)
          })
          .catch(() => {
            this.handleError("wall.manager.editor.errors.create")
          })
          .finally(() => this.disableAntiSpam())
    },
    deleteWall() {
      if (confirm(this.$t("wall.manager.editor.confirm.delete"))) {
        this.enableAntiSpam()
        this.$axios
            .delete("office/manager/wall", {params: {id: this.wall.id}})
            .then(() => {
              this.handleSuccess("wall.manager.editor.success.delete")
              window.location.reload()
            })
            .catch(() => {
              this.handleError("wall.manager.editor.errors.delete")
            })
            .finally(() => this.disableAntiSpam())
      }
    },
    updateWall() {
      this.enableAntiSpam()
      let wall = {...this.wall}
      if (Array.isArray(wall.meta_tags)) {
        wall.meta_tags = wall.meta_tags.join(",")
      } else {
        wall.meta_tags = null
      }

      let formData = new FormData()

      formData.append("address", this.wall.address)
      formData.append("category_id", this.wall.category_id)
      formData.append("description", this.wall.description)
      formData.append("title", this.wall.title)
      formData.append("domain", this.wall.domain)
      formData.append("id", this.wall.id)
      formData.append("meta_tags", this.wall.meta_tags)
      formData.append("meta_description", this.wall.meta_description)
      formData.append("meta_title", this.wall.meta_title)

      let count = 1

      this.images.forEach(image => {
        formData.append("image_" + count, image)
        count++
      })

      this.$axios
          .post("office/manager/wall", formData, {headers: {"content-type": "multipart/form-data"}})
          .then(response => {
            this.cleanWallResponse(response)
            this.reloadWallIframe()
            this.handleSuccess("wall.manager.editor.success.update")
          })
          .catch(() => {
            this.handleError("wall.manager.editor.errors.update")
          })
          .finally(() => this.disableAntiSpam())
    },
    removeRemainingBadCharacters() {
      let domain = this.domain
      if (domain.endsWith("-")) {
        domain = domain.substr(0, domain.length - 1)
      }

      if (domain.startsWith("-")) {
        domain = domain.substr(1, domain.length)
      }

      this.$nextTick(() => {
        this.domain = domain
      })

      this.domainTypingTimeout = null
    },
    cleanDomain(value) {
      if (this.domainTypingTimeout === null) {
        this.domainTypingTimeout = window.setTimeout(this.removeRemainingBadCharacters, 2000)
      }

      let domain = value
      domain = domain.toLowerCase()

      domain = domain.replace(/\s/g, "-")
      domain = domain.replace(/[^a-z0-9-]/g, "")
      domain = domain.replace(/-+/g, "-")

      domain = domain.trim()

      // 63 octets - .securating.pro (15) = up to 48 octets
      domain = domain.substr(0, 47)

      this.$nextTick(() => {
        this.domain = domain
      })
    },
    renderContent() {
      this.wall.description = this.editorContent
    },
    openTokenDialog(site) {
      this.tokenDialog = true
      this.tokenSite = site
      this.tokenLoading = true
      this.usedTokens = {}
      this.fetchTokens()
    },
    linkToken(plan) {
      this.tokenLoading = true

      const token = this.tokens[plan].shift()

      this.usedTokens = {
        [plan]: [],
      }

      this.usedTokens[plan].push(token)

      this.$axios
          .patch("/office/manager/subscription/token/use", {
            hash: token.hash,
            subscription_id: token.subscription_id,
            website_id: this.tokenSite.websites_id,
          })
          .then(() => {
            this.websites.find(site => site.websites_id === this.tokenSite.websites_id).plan_id = plan
            this.fetchTokens()
          })
    },
    fetchTokens() {
      this.$axios
          .get("/office/manager/subscription/tokens", {
            params: {
              website_id: this.tokenSite.websites_id,
            },
          })
          .then(response => {
            this.tokens = groupBy(response.data.data.tokens, "plan")
            this.usedTokens = groupBy(response.data.data.used_tokens, "plan")
          })
          .finally(() => (this.tokenLoading = false))
    },
    addWebsite() {
      return new Promise((resolve, reject) => {
        if (!this.websites.some(site => site.host === this.form.host)) {
          this.$axios
              .post("/site/certificate", this.form)
              .then(response => {
                this.form.public_key = response.data.data
                this.form.plan = this.$t("websites.plan.free")

                // Push the new website on the table
                this.websites.unshift({...this.form})
                this.form = {}
                resolve()
              })
              .catch(errors => {
                reject(errors.response.data)
              })
        }
      })
    },
    getWebsites() {
      this.$axios.get("/site/certificate").then(response => {
        this.websites = response.data
      })
    },
    shorterHash(hash) {
      if (hash.length >= 6) {
        return hash.slice(0, 6) + "..."
      }
      return hash
    },
    rateNow(site) {
      this.$axios.post("/site/ratedomain", {
        website_id: site.websites_id,
      })
    },
    verify(site) {
      this.loading = site.public_key
      site.verified = -1

      this.$axios
          .post("/site/certificate/verify", site)
          .then(response => {
            site.verified = response.data.data

            let snackbarText = ""
            let snackbarColor = ""

            if (site.verified === 0) {
              snackbarText = this.$t("websites.verification.level0")
              snackbarColor = "error"
            }
            if (site.verified === 1) {
              snackbarText = this.$t("websites.verification.level1")
              snackbarColor = "success"
            }
            if (site.verified === 2) {
              snackbarText = this.$t("websites.verification.level2")
              snackbarColor = "success"
            }
            if (snackbarText !== "") {
              this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
                lines: snackbarText,
                config: {timeout: 3 * 1000, color: snackbarColor},
              })
            }
            this.loading = null
          })
          .catch(() => {
            this.loading = null
            site.verified = 0
          })
    },
    openRemoveDialog(site) {
      this.website = site
      this.removeDialog = true
    },
    openActionsDialog(site) {
      this.website = site;
      if (site.authorized_hosts === "null" || site.authorized_hosts === null || site.authorized_hosts === "{}" || site.authorized_hosts === "[]") {
        this.authorizedHosts = []
      } else {
        this.authorizedHosts = JSON.parse(site.authorized_hosts)
      }
      this.actionsDialog = true
    },
    openEditDialog(site) {
      this.website = site;
      if (site.authorized_hosts === "null" || site.authorized_hosts === null || site.authorized_hosts === "{}" || site.authorized_hosts === "[]") {
        this.authorizedHosts = []
      } else {
        this.authorizedHosts = JSON.parse(site.authorized_hosts)
      }
      this.editDialog = true
    },

    saveWebsiteData() {
      this.$axios
          .post("/site/certificate/authorized_hosts", {authorized_hosts: this.authorizedHosts, site: this.website})
          .then(() => {
            this.getWebsites()
            this.editDialog = false
          })
          .catch(() => (this.actionsDialog = false))
    },
    updateWebsiteLogo(image) {
      this.website.logo = image.url
      this.saveWebsiteData()
    },
    openResetDialog(site) {
      this.website = site
      this.resetDialog = true
    },
    reset(site) {
      this.$axios
          .post("/site/certificate/reset", site)
          .then(response => {
            site.public_key = response.data.data
            this.resetDialog = false
          })
          .catch(() => (this.resetDialog = false))
    },
    del(site) {
      this.$axios
          .delete("/site/certificate", {data: site})
          .then(() => {
            this.websites = this.websites.filter(website => website.public_key !== site.public_key)
            this.removeDialog = false
            this.actionsDialog = false
          })
          .catch(() => (this.removeDialog = false))
    },
    downloadToken(site) {
      let element = document.createElement("a")
      let filename = "securating_" + site.public_key.substring(0, 6) + ".txt"
      element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(site.public_key))
      element.setAttribute("download", filename)
      element.style.display = "none"
      document.body.appendChild(element)
      element.click()
      document.body.removeChild(element)
    },
    downloadReviews(site) {
      this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
        lines: this.$t("websites.download.requested"),
        config: { timeout: 3 * 1000, color: "success" },
      })
      this.$axios
          .post("/site/reviews", {website_id: site.id})
          .then(response => {
            let reviews = response.data
            if(reviews!=="Building requested datas") {
              let element = document.createElement("a")
              let filename = "publications-"+site.host+".csv"
              element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(reviews))
              element.setAttribute("download", filename)
              element.style.display = "none"
              document.body.appendChild(element)
              element.click()
              document.body.removeChild(element)
            }
          })
    },
  },
}
</script>
